import React from "react";
import { SeekerStatus } from "../types/seeker";

const styles: Record<SeekerStatus | 'suspended', React.CSSProperties> = {
    new: { background: "#DBEAFE", color: "#1D4ED8", border: "1px solid #BFDBFE" },
    active: { background: "#ECFDF5", color: "#047857", border: "1px solid #A7F3D0" },
    inactive: { background: "#F3F4F6", color: "#4B5563", border: "1px solid #E5E7EB" },
    no_match: { background: "#FEE2E2", color: "#DC2626", border: "1px solid #FCA5A5" },
    suspended: { background: "#FEE2E2", color: "#DC2626", border: "1px solid #FCA5A5" },
};

const displayLabels: Record<SeekerStatus, string> = {
    new: 'New',
    active: 'Active',
    inactive: 'Inactive',
    no_match: 'No Match',
};

export default function SeekerStatusBadge({ status, blocked }: { status: SeekerStatus; blocked?: boolean }) {
    const displayStatus = blocked ? 'suspended' : status;
    const displayText = blocked ? 'Suspended' : displayLabels[status];

    return (
        <span
            style={{
                ...styles[displayStatus],
                fontSize: 12,
                padding: "2px 8px",
                borderRadius: 999,
                display: "inline-block",
                lineHeight: "18px",
            }}
        >
            {displayText}
        </span>
    );
}

